<template>
  <div class="img-container">
    <img width="100%" :src="image" />
    <h2>Software Architect specializing in Backend & Blockchain engineering</h2>
  </div>
</template>

<script>
import image from '../../static/paul-oostenrijk.gif'

export default {
  data: () => ({
    image
  })
}
</script>

<style>
  .img-container {
    padding: 40px 20px 20px 20px;
    text-align: center;
  }

  .img-container h2 {
    font-size: 16px;
    margin-top: 10px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// HeaderGif.vue?36d38aa8